<template>
  <div id="map"></div>
</template>
<script>
export default {
  data() {
    return {
      maps: null
    };
  },
  methods: {
    init(res) {
      this.maps = new qq.maps.Map('map', {
        center: new qq.maps.LatLng(39.2111082131, 118.60994338989),
        zoom: 12
      });
      // this.calcpoli(res);
    }
    // calcpoli(res) {
    //   //从结果中取出路线坐标串
    //   var coors = res,
    //     pl = [];
    //   //坐标解压（返回的点串坐标，通过前向差分进行压缩，因此需要解压）
    //   var kr = 1000000;
    //   for (let i = 2; i < coors.length; i++) {
    //     coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr;
    //   }
    //   //将解压后的坐标生成LatLng数组
    //   for (let i = 0; i < coors.length; i += 2) {
    //     pl.push(new TMap.LatLng(coors[i], coors[i + 1]));
    //   }
    //   this.routePoliy(pl);
    // },
    // routePoliy(res) {
    //   new TMap.MultiPolyline({
    //     id: 'BICYCLING', //图层唯一标识
    //     map: this.maps, //绘制到目标地图
    //     //折线样式定义
    //     styles: {
    //       style_blue: new TMap.PolylineStyle({
    //         color: '#3777FF', //线填充色
    //         width: 3, //折线宽度
    //         borderWidth: 1, //边线宽度
    //         borderColor: '#FFF', //边线颜色
    //         lineCap: 'round' //线端头方式
    //       })
    //     },
    //     //折线数据定义
    //     geometries: [
    //       {
    //         id: 'pl_1', //折线唯一标识，删除时使用
    //         styleId: 'style_blue', //绑定样式名
    //         paths: res
    //       }
    //     ]
    //   });
    //初始化地图
  }
};
</script>

<style lang="stylus" scoped>
#map {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>